import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ApiService from "services/ApiService";
import ToastUtils from "utils/ToastUtils";
import ValidationService from "services/ValidationService";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import Input from "components/CustomFields/Input";

function CreateCompany() {
  const [vatInfoStatus, setVatInfoStatus] = useState(true);
  const [saveCompanyStatus, setSaveCompanyStatus] = useState(false);
  const [vatNumber, setVatNumber] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [friendlyName, setFriendlyName] = useState("");
  const [companyBusiness, setCompanyBusiness] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [addressNo, setAddressNo] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [companyGemi, setCompanyGemi] = useState(null);
  const [companyEmail, setCompanyEmail] = useState("");
  const [companyTaxOffice, setCompanyTaxOffice] = useState("");

  const [vatNumberError, setVatNumberError] = useState(false);
  const [friendNameError, setFriendlyNameError] = useState(false);
  const [companyNameError, setCompanyNameError] = useState(false);
  const [companyBusinessError, setCompanyBusinessError] = useState(false);
  const [cityError, setCityError] = useState(false);
  const [addressError, setAddressError] = useState(false);
  const [addressNoError, setAddressNoError] = useState(false);
  const [postalCodeError, setPostalCodeError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [companyTaxOfficeError, setCompanyTaxOfficeError] = useState(false);

  const navigate = useNavigate();

  const handleCompanyNameChange = (value) => {
    setCompanyNameError(false);
    setCompanyName(value);
  };
  const handleFriendlyNameChange = (value) => {
    setFriendlyNameError(false);
    setFriendlyName(value);
  };

  const handleCompanyBusinessChange = (value) => {
    setCompanyBusinessError(false);
    setCompanyBusiness(value);
  };
  const handleCityChange = (value) => {
    setCityError(false);
    setCity(value);
  };
  const handleAddressChange = (value) => {
    setAddressError(false);
    setAddress(value);
  };
  const handleAddressNoChange = (value) => {
    setAddressNo(value);
    setAddressNoError(false);
  };
  const handlePostalCodeChange = (value) => {
    setPostalCode(value);
    setPostalCodeError(false);
  };

  const handleEmailChange = (value) => {
    setCompanyEmail(value);
    setEmailError(false);
  };

  const handleTaxOfficeChange = (value) => {
    setCompanyTaxOffice(value);
    setCompanyTaxOfficeError(false);
  };

  const handleVatNumberChange = (value) => {
    setVatInfoStatus(true);
    setVatNumberError(false);
    if (value.length > 9) return;
    setVatNumber(value);
    if (value.length === 9) setVatInfoStatus(false);
  };

  const searchVatInfo = async () => {
    setVatInfoStatus(true);
    const response = await ApiService.getData(
      `/api/v2/state-services/get-gov-data-for-vat?vatNumber=${vatNumber}`
    );
    if (!response) {
      ToastUtils.error("Αδυναμία άντλησης στοιχείων!");
      setVatInfoStatus(false);
      return;
    }
    ToastUtils.success("Επιτυχία άντλησης στοιχείων!");
    setVatInfoStatus(false);

    const govData = response.data;

    handleCompanyNameChange(_.get(govData, "basic.onomasia", ""));
    handleCityChange(_.get(govData, "basic.postalAreaDescription", ""));
    handleAddressChange(_.get(govData, "basic.postalAddress", ""));
    handleAddressNoChange(_.get(govData, "basic.postalAddressNo", ""));
    handlePostalCodeChange(_.get(govData, "basic.postalZipCode", ""));
    handleTaxOfficeChange(_.get(govData, "basic.doyDescr", ""));
    let kyriaDratiriotita = response.data.epaggelmata.find((el) => el.firmActKind === "1");
    if (!kyriaDratiriotita) return;
    handleCompanyBusinessChange(kyriaDratiriotita.firmActDescr);
  };

  const createCompany = async () => {
    setSaveCompanyStatus(true);
    const company = {
      email: companyEmail,
      vatNumber: vatNumber,
      country: "GR",
      name: companyName,
      friendlyName: friendlyName,
      business: companyBusiness,
      street: address,
      streetNumber: addressNo,
      postalCode: postalCode,
      city: city,
      gemi: companyGemi,
      documentIdNo: null,
      supplyAccountNo: null,
      countryDocumentId: null,
      taxOffice: companyTaxOffice,
    };

    const valErrors = ValidationService.validateCompany(company);

    if (valErrors) {
      handleValidationError(valErrors);
      setSaveCompanyStatus(false);
      return;
    }

    const response = await ApiService.postData(`/api/v1/companies`, company);

    if (!response) {
      ToastUtils.error("Αδυναμία δημιουργίας εταιρείας");
      setSaveCompanyStatus(false);
      return;
    }

    ToastUtils.success("Επιτυχής δημιουργία εταιρείας");
    navigate("/companies/companies-list");
  };

  const handleValidationError = (error) => {
    console.error(error);
    let pathName = _.get(error, "details[0].path[0]");
    switch (pathName) {
      case "vatNumber":
        setVatNumberError(true);
        return;
      case "friendlyName":
        setFriendlyNameError(true);
        return;
      case "name":
        setCompanyNameError(true);
        return;
      case "business":
        setCompanyBusinessError(true);
        return;
      case "street":
        setAddressError(true);
        return;
      case "streetNumber":
        setAddressNoError(true);
        return;
      case "postalCode":
        setPostalCodeError(true);
        return;
      case "city":
        setCityError(true);
        return;
      case "email":
        setCompanyEmail(true);
        return;
      case "taxOffice":
        setCompanyTaxOfficeError(true);
        return;
      default:
        ToastUtils.error("Αδυναμία επαλήθευσης στοιχείων!");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox mt={3} mb={4}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={9}>
            <Card sx={{ overflow: "visible" }}>
              <SoftBox p={2} lineHeight={1}>
                <SoftTypography variant="h6" fontWeight="medium">
                  Δημιουργία Εταιρείας
                </SoftTypography>
                <SoftTypography variant="button" fontWeight="regular" color="text">
                  Καταχωρήστε τα στοιχεία της εταιρείας σας για να αποκτήσετε κλειδάριθμο για τη
                  διασύνδεση με την υπηρεσίας μας.
                </SoftTypography>
                <Divider />

                <Grid container spacing={3}>
                  <Input
                    xs={12}
                    md={6}
                    title="ΑΦΜ"
                    handler={handleVatNumberChange}
                    type="number"
                    value={vatNumber}
                    error={vatNumberError}
                  />

                  <Grid item xs={12} md={6}>
                    <SoftBox
                      display="flex"
                      flexDirection="column"
                      justifyContent="flex-end"
                      height="100%"
                    >
                      <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                          Αναζήτηση στοιχείων στη ΓΓΠΣ
                        </SoftTypography>
                      </SoftBox>
                      <SoftButton color="success" disabled={vatInfoStatus} onClick={searchVatInfo}>
                        αναζητηση
                      </SoftButton>
                    </SoftBox>
                  </Grid>
                </Grid>

                <Grid container spacing={3}>
                  <Input
                    xs={12}
                    md={6}
                    title="Φιλική Ονομασία"
                    handler={handleFriendlyNameChange}
                    value={friendlyName}
                    error={friendNameError}
                  />
                  <Input
                    xs={12}
                    md={6}
                    title="Email"
                    handler={handleEmailChange}
                    type="email"
                    value={companyEmail}
                    error={emailError}
                  />
                </Grid>
                <Grid container spacing={3}>
                  <Input
                    xs={12}
                    md={6}
                    title="Επωνυμία"
                    handler={handleCompanyNameChange}
                    initialValue={companyName}
                    error={companyNameError}
                  />
                  <Input
                    xs={12}
                    md={6}
                    title="Δραστηριότητα"
                    handler={handleCompanyBusinessChange}
                    initialValue={companyBusiness}
                    error={companyBusinessError}
                  />
                </Grid>
                <Grid container spacing={3}>
                  <Input
                    xs={12}
                    md={6}
                    title="ΔΟΥ"
                    handler={handleTaxOfficeChange}
                    initialValue={companyTaxOffice}
                    error={companyTaxOfficeError}
                  />
                  <Input
                    xs={12}
                    md={6}
                    title="Αριθμός Γ.Ε.ΜΗ."
                    handler={setCompanyGemi}
                    initialValue={companyGemi}
                  />
                </Grid>
                <Grid container spacing={3}>
                  <Input
                    xs={12}
                    md={6}
                    title="Διεύθυνση"
                    handler={handleAddressChange}
                    initialValue={address}
                    error={addressError}
                  />
                  <Input
                    xs={12}
                    md={6}
                    title="Αριθμός Διεύθυνσης"
                    handler={handleAddressNoChange}
                    initialValue={addressNo}
                    error={addressNoError}
                  />
                </Grid>

                <Grid container spacing={3}>
                  <Input
                    xs={12}
                    md={6}
                    title="Πόλη"
                    handler={handleCityChange}
                    initialValue={city}
                    error={cityError}
                  />
                  <Input
                    xs={12}
                    md={6}
                    title="Τ.Κ."
                    handler={handlePostalCodeChange}
                    initialValue={postalCode}
                    error={postalCodeError}
                  />
                </Grid>

                <SoftBox display="flex" justifyContent="flex-end" mt={3}>
                  <SoftButton
                    variant="gradient"
                    color="info"
                    style={{ width: "100%" }}
                    onClick={createCompany}
                    disabled={saveCompanyStatus}
                  >
                    ΔΗΜΙΟΥΡΓΙΑ
                  </SoftButton>
                </SoftBox>
              </SoftBox>
            </Card>
          </Grid>
        </Grid>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CreateCompany;
